export default {
  en: {
    title: 'Notifications',
    subtitle: 'Send notifications to your account users.',
    columns: {
      name: 'Integration id',
      label: 'Nombre',
      visibility: 'Visibility',
    },
    form: {
      label: {
        error: 'Enter a valid abandon reason.',
        hint: 'The abandon reason will be visible by your customers.',
      },
      name: {
        error: 'Please enter a integration id.',
        hint: 'This is the id of integration will be send on webhooks.',
      },
      visibility: {
        hint: 'Select if you want this abandon reason will be visible for your customers.',
      },
    },
  },
  es: {
    title: 'Notificaciones',
    subtitle: 'Envía notificaciones a los usuarios de tu cuenta.',
    columns: {
      name: 'Id Integración',
      label: 'Nombre',
      visibility: 'Visibilidad',
    },
    form: {
      label: {
        error: 'Ingresa una razón de abandono válida.',
        hint: 'Nombre de la razón de abandono que será visible por tus clientes.',
      },
      name: {
        error: 'Por favor ingrese el id de integración.',
        hint: 'Este es un id de integración el cual será enviado en webhooks.',
      },
      visibility: {
        hint: 'Selecciona si deseas que la razón de abandono será visible por sus cliente o no.',
      },
    },
  },
  fr: {
    title: 'Notifications',
    subtitle: 'Envoyez des notifications aux utilisateurs de votre compte.',
    columns: {
      name: 'ID d\'Intégration',
      label: 'Nom',
      visibility: 'Visibilité',
    },
    form: {
      label: {
        error: 'Entrez un nom de raison d\'abandon valide.',
        hint: 'Nom de la raison d\'abandon qui sera visible par vos clients.',
      },
      name: {
        error: 'Veuillez entrer l\'ID d\'intégration.',
        hint: 'Il s\'agit d\'un ID d\'intégration qui sera envoyé dans les webhooks.',
      },
      visibility: {
        hint: 'Sélectionnez si vous souhaitez que la raison d\'abandon soit visible par vos clients ou non.',
      },
    },
}

};
